import { Injectable } from '@angular/core';
import { TemplateInterface } from '../interfaces/template.interface';

@Injectable()
export class ZebraTemplateService {
    /**
     * A collection of actions and their corresponding filters.
     *
     * @type Array<TemplateInterface>
     */
    private templates = Array<TemplateInterface>();

    /**
     * Constructor
     */
    constructor() {
        //
    }

    /**
     * Register a template
     *
     * Example:
     * zebraTemplateService.addTemplate('example', (data) => {
     *   const zebraBrowserPrint = new ZebraBrowserPrint();
     *   zebraBrowserPrint.connectPrinter(() => {
     *     zebraBrowserPrint.startZpl();
     *     zebraBrowserPrint.addText(0, zebraBrowserPrint.coords.y, data.name);
     *     zebraBrowserPrint.endZpl();
     *     zebraBrowserPrint.print();
     *   });
     * });
     *
     * @param {string} name
     * @param {any} callback
     * @return {boolean}
     */
    public addTemplate(name: string, callback: any) {
        // Check if a template with that name already exists
        if (this.templates.find(template => template.name === name)) {
            return false;
        }

        this.templates.push({
            name: name,
            callback: callback
        });

        return true;
    }

    /**
     * Remove a template by name (if it exists)
     *
     * @param {string} name
     * @return void
     */
    public removeTemplate(name: string) {
        this.templates = this.templates.filter(template => template.name !== name);
    }

    /**
     * Print a label corresponding to the template name and data given.
     *
     *
     * @param {string} name
     * @param {array} data
     * @param {number} amount (optional, default: 1)
     * @returns {boolean}
     */
    public printTemplate(name: string, data: any, amount: number = 1) {
        const templateToPrint = this.templates.find(template => template.name === name);

        if (!templateToPrint) {
            return false;
        }

        data['zebra-label-print']          = [];
        data['zebra-label-print']['total'] = amount;
        for (let i = 0; i < amount; i++) {
            data['zebra-label-print']['current'] = (i + 1);

            templateToPrint.callback(data);
        }

        return true;
    }
}


// WEBPACK FOOTER //
// ./libs/zebra-print/src/app/services/zebra-template.service.ts